module.exports = __webpack_public_path__ + "static/img/img4.15c64f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img4.png
// module id = 2HVc
// module chunks = 3